var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnabled)?_c('conditional-free-contents-container',{attrs:{"brand-english-name":_vm.brandEnglishName,"contents-name":"ShipmentSuspendFreeArea"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }